import React, { useEffect, useRef } from "react";
import { drawStaticElements } from "./drawStaticElements";

export const StaticLayoutRenderer = React.memo(({ layout, isPrint }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) {
      return;
    }

    canvasRef.current.innerHTML = "";
    drawStaticElements({ canvas: canvasRef.current, layout, isPrint });
  }, [layout, isPrint]);

  return (
    <svg
      id="printTopologyId"
      ref={canvasRef}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      className="position-relative overflow-visible"
    />
  );
});
